import { render, staticRenderFns } from "./editLocationTargetingDetails.vue?vue&type=template&id=52c22934&scoped=true&"
import script from "./editLocationTargetingDetails.vue?vue&type=script&lang=js&"
export * from "./editLocationTargetingDetails.vue?vue&type=script&lang=js&"
import style0 from "./editLocationTargetingDetails.vue?vue&type=style&index=0&id=52c22934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c22934",
  null
  
)

export default component.exports